import React from 'react';
import styles from './ClientDashboardCard.module.scss';
import Man from 'assets/images/company_men.svg';
import { ClientDashboardCardProps } from 'enums/ClientDashboardCardEnums';
import clsx from 'clsx';
import ClientDashbaordCardWithEmission from './ClientDashbaordCardWithEmission';
import formatNumberWithCommas from 'shared/utils/formatNumberWithComma';

interface DashboardCardProps {
  product?: boolean;
  goalValueCompany?: number | undefined;
  goalValueAllProducts: number;
  totalcarbonEmissionOfCompany?: number | undefined;
  totalcarbonEmissionOfAllProducts?: number | undefined;
  handleOpenModal?: () => void;
}

const ClientDashboardCard: React.FC<DashboardCardProps> = ({
  product,
  goalValueAllProducts,
  goalValueCompany,
  totalcarbonEmissionOfAllProducts,
  totalcarbonEmissionOfCompany,
  handleOpenModal,
}: DashboardCardProps) => {
  const showEmissionHeader = product && totalcarbonEmissionOfAllProducts;
  const showGAndCompany = totalcarbonEmissionOfCompany && goalValueCompany;

  return (
    <>
      {showEmissionHeader ? (
        <ClientDashbaordCardWithEmission
          totalcarbonEmissionOfAllProducts={totalcarbonEmissionOfAllProducts}
          goalValueAllProducts={goalValueAllProducts}
          handleOpenModal={handleOpenModal}
        />
      ) : (
        showGAndCompany && (
          <div
            className={clsx({
              [styles.cardContainer]:
                totalcarbonEmissionOfCompany <= goalValueCompany,
              [styles.cardContainerRed]:
                totalcarbonEmissionOfCompany > goalValueCompany,
            })}>
            <div className={styles.leftContainer}>
              <h2>{ClientDashboardCardProps.HEADING_COMPANY}</h2>
              <h1>
                {formatNumberWithCommas(totalcarbonEmissionOfCompany)}{' '}
                <span>
                  {ClientDashboardCardProps.CO}
                  <sub>{ClientDashboardCardProps.SUBSCRIPT}</sub>
                  {ClientDashboardCardProps.POST_SUBSCRIPT}
                </span>
              </h1>
              <p onClick={handleOpenModal}>
                {ClientDashboardCardProps.EDIT_GOAL_LABEL}
              </p>
            </div>
            <div className={styles.rightContainer}>
              {totalcarbonEmissionOfCompany <= goalValueCompany && (
                <img
                  src={Man}
                  alt={ClientDashboardCardProps.MAN_ILLUSTRATION_ALT}
                  className={styles.illustration}
                />
              )}
            </div>
          </div>
        )
      )}
    </>
  );
};

export default ClientDashboardCard;
